<button type="submit" [class]="buttonClass" (click)="onClick()" [disabled]="disabled">
  <span *ngIf="!loading" [innerHtml]="text"></span>
  <svg *ngIf="loading" class="spinner" viewBox="0 0 50 50" [style.height]="svgSpinnerHeight">
    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
  </svg>
</button>
